import React, {useRef, useState, useEffect, useCallback} from 'react';
import {MUTES, DELETE} from "components/pads/modes.js";
const MIN_TIME = 250;
const MIN = -65;

export const useVolumeMove = (
    ref,
    track,
    setParameterSliderDown,
    mode
) => {
    let lastClick = useRef(0);
    let [mouseDown, setMouseDown] = useState(false);
    let [pt, setPt] = useState(undefined);
    let [moved, setMoved] = useState(false);

    const onMouseLeave = useCallback(() => {
        setMouseDown(false);
        setMoved(undefined);
        setParameterSliderDown(undefined);
    }, [setMouseDown, setMoved]);

    const onMouseMove = useCallback((e) => {
        if (e.metaKey || mode === DELETE || mode === MUTES || !mouseDown || !track) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        
        let clientY = e.clientY;
        if (e.touches) {
            clientY = e.touches[0].clientY;
        }
        let el = ref.current.getBoundingClientRect();
        let height = ref.current.offsetHeight;
        let y = height - (clientY - el.top);
        let vol = getVolume(y, MIN, 6, height);
        track.setVolume(vol, false, false);
        setMoved({x: e.clientX, y: e.clientY});
    }, [setMoved, mouseDown, track, mode]);

    const onMouseDown = useCallback((e) => {
        if (e.metaKey || e.ctrlKey || mode === DELETE || mode === MUTES) {
            return;
        }
        if (!track) { return; }
        setParameterSliderDown(track.volumeParameter);
        setMouseDown(true);
        setPt({x: e.clientX, y: e.clientY});
        lastClick.current = new Date().getTime();
    }, [setMouseDown, setPt, track, mode]);

    const onMouseUp = useCallback((e) => {
        if (e.metaKey) {
            return;
        }
        setMoved(undefined);
        setMouseDown(false);
        setParameterSliderDown(undefined);
    }, [setMoved, setMouseDown, moved, pt]);

    let innerStyle = {
        height: track && getHeight(track.volumeParameter.get(), MIN, 6, ref.current && ref.current.offsetHeight)
    };
    
    return {
        innerStyle,
        onMouseLeave,
        onMouseDown,
        onMouseUp,
        onMouseMove,
        mouseDown
    };
};

const dist = (pt1, pt2) => {
    return Math.abs(pt1.y - pt2.y);
};

function getVolume(x, min=-40, max=6, height) {
    x = Math.min(Math.max(0, x), height);
    let ratio = x / height;
    let fullRatio = Math.pow(ratio, 0.5);
    return min + (max - min) * fullRatio;
}

function getHeight(volume, min=-40, max=6, height) {
    let ratio = getVolumeRatio(volume, min, max, height);
    return height * Math.pow(ratio, 2);
}

function getVolumeRatio(volume, min=-40, max=6) {
    return (volume - min) / (max - min);
}

const sq = (x) => x*x;
const sqrt = (x) => Math.sqrt(x);

